import { render, staticRenderFns } from "./ChannelPart2.vue?vue&type=template&id=9cab7672&scoped=true&"
import script from "./ChannelPart2.vue?vue&type=script&lang=js&"
export * from "./ChannelPart2.vue?vue&type=script&lang=js&"
import style0 from "./ChannelPart2.vue?vue&type=style&index=0&id=9cab7672&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cab7672",
  null
  
)

export default component.exports